import { useState, useCallback, useEffect } from 'react';

import { getList } from 'api/organization';
import OrganizationDomain from 'domain/organization';

export const useOrganizationList = () => {
  const [organizationList, setOrganizationList] = useState<Array<OrganizationDomain>>([]);
  const [noManager, setNoManager] = useState(false);
  const [orgStatus, setOrgStatus] = useState<'0'|'1'>('0');
  const [unsetTargetDate, setUnsetTargetDate] = useState<Date>(new Date());
  const [blocking, setBlocking] = useState(false);

  // データの取得
  const fetchData = useCallback(async () => {
    setBlocking(true);
    const response = await getList(
      noManager,
      Number(orgStatus),
      new Date(),
      noManager ? unsetTargetDate : undefined,
    );
    setOrganizationList(response.map((result) => new OrganizationDomain(result)));
    setBlocking(false);
  }, [noManager, orgStatus, unsetTargetDate]);

  useEffect(() => {
    fetchData();
  }, [fetchData, noManager, orgStatus, unsetTargetDate]);

  const toggleNoManager = useCallback(() => {
    setNoManager(!noManager);
  }, [noManager]);

  return {
    organizationList,
    fetchData,
    noManager,
    toggleNoManager,
    orgStatus,
    setOrgStatus,
    unsetTargetDate,
    setUnsetTargetDate,
    blocking,
  };
};

export default {};
